<template>
  <v-dialog v-model="active" persistent width="60%">
    <v-card class="black--text" color="cardbg">
      <v-card-title class="headline font-weight-bold">
        {{ title }}
      </v-card-title>
      <v-card-text class="subtitle-1 font-weight-medium font-regular">
        <span class="font-weight-bold card-text-color" v-html="getText"> </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="mb-2 importantbutton"
          rounded
          depressed
          @click="closeButtonAction"
          >{{ closebuttonLabel }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  computed: {
    successDialog() {
      return this.$store.getters["success/successDialog"];
    },
    active() {
      return this.successDialog.active;
    },
    title() {
      return this.$t(this.successDialog.title);
    },
    closebuttonLabel() {
      return this.$t(this.successDialog.closeButtonLabel);
    },
    getText() {
      if (this.successDialog.params?.msg) {
        return this.$t(this.successDialog.message, {
          ...this.successDialog.params.msg
        });
      } else {
        return this.$t(this.successDialog.message);
      }
    }
  },
  methods: {
    closeButtonAction() {
      if (this.successDialog.closeButtonClb) {
        this.successDialog.closeButtonClb();
      }
      this.$store.commit("success/RESET", {
        root: true
      });
    }
  }
};
</script>
